import { Component } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	templateUrl: './rbe-generic-entry-info.dialog.component.html',
	styles: `
	`
})

export class RbeGenericEntryInfoDialogComponent {
	constructor(
		private refDialog: DynamicDialogRef
	) {}

	closeDialog(): void {
		this.refDialog.close();
	}

}